/* eslint-disable react/jsx-pascal-case */
import React from 'react';
import R_ColumnMatch from './R_ColumnMatch';
import R_MultipleChoice from './R_MultipleChoice';
import R_Order from './R_Order';
import R_SelectTrue from './R_SelectTrue';
import R_Type from './R_Type';

export default function ReviewQuestion(props) {
  const question = props.question;
  const submission = props.submission;
  const questionNumber = props.questionNumber;
  var options = JSON.parse(localStorage.getItem('Options'));

  function sortOutReviewTypes() {
    var content;
    if (question === undefined || question.type === undefined) return <></>;
    switch (question.type) {
      case 'single':
        content = <R_MultipleChoice question={question} options = {options} submission={submission} questionNumber={questionNumber} />;
        break;
      case 'multiple':
        content = <R_SelectTrue question={question} options = {options} submission={submission} questionNumber={questionNumber} />;
        break;
      case 'order':
        content = <R_Order question={question} options = {options} submission={submission} questionNumber={questionNumber} />;
        break;
      case 'match':
        content = <R_ColumnMatch question={question} options = {options} submission={submission} questionNumber={questionNumber} />;
        break;
      case 'number':
        content = <R_Type question={question} options = {options} submission={submission} questionNumber={questionNumber} />;
        break;
      case 'text':
        content = <R_Type question={question} submission={submission} questionNumber={questionNumber} />;
        break;
      case 'true/false':
        content = <R_MultipleChoice question={question} submission={submission} questionNumber={questionNumber} />;
        break;
    }
    return <>{content}</>;
  }

  return (
    <>
      <link
        href={'https://cdnjs.cloudflare.com/ajax/libs/KaTeX/0.9.0/katex.min.css'}
        rel={'stylesheet'}
      />
      {sortOutReviewTypes()}
    </>
  );
}
